import { createSelector } from 'reselect'

import { selectAssortmentState } from './selectAssortmentState'

export const selectAssortmentSettingsCategoriesStatus = createSelector(
  [selectAssortmentState],
  (state) => {
    return state.categories.status
  }
)
